"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDynamicColumns = buildDynamicColumns;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const dynamicColumns_1 = require("../../../../ui/components/EntityTable/dynamicColumns");
const react_1 = __importDefault(require("react"));
function buildDynamicColumns(dynamicColumnData) {
    if (dynamicColumnData) {
        return dynamicColumnData.columnDefs
            .filter((columnDef) => columnDef.metadata?.showInTable)
            .map((columnDef) => ({
            headerLabel: columnDef.metadata?.label,
            cellFunction: (row) => (react_1.default.createElement(DataTable_1.TextCell, null, (0, dynamicColumns_1.formatDynamicColumnValue)(row, columnDef, dynamicColumnData.handlerMap.get(columnDef.metadata?.columnHandlerName ?? '')))),
        }));
    }
    else {
        return [];
    }
}
